/* eslint-disable */
import { GraphQLClient, RequestOptions } from 'graphql-request';
import gql from 'graphql-tag';
export type Maybe<T> = T | undefined;
export type InputMaybe<T> = T | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
type GraphQLClientRequestHeaders = RequestOptions['requestHeaders'];
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A hexadecimal RGB color value like "#FF0000" */
  Color: { input: any; output: any; }
  /** An opaque cursor for pagination */
  Cursor: { input: any; output: any; }
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: { input: Date | string; output: string; }
  /**
   * A string representing a point in time in an [ISO Format](https://en.wikipedia.org/wiki/ISO_8601)
   *
   *   When providing a `DateInput` argument you can choose from multiple different formats:
   *   - `"yyyy-MM-dd"` for just a Date: e.g. `"2022-05-13"` will be interpreted as May 13th 2022, 00:00:00h _UTC_
   *   - `"yyyy-MM-dd[T]HH:mm"` or `"yyyy-MM-dd HH:mm"` for a date with time: e.g. `"2022-05-13 15:30"` will be interpreted as May 13th 2022, 15:30:00h in our _default timezone Europe/Vienna_, which is 14:30 _UTC_
   *   - `"yyyy-MM-dd[T]HH:mm:ss[Z]"` for a UTC timestamp: e.g. `"2022-05-13T15:30:00Z"` with the Z denoting zero UTC offset will be interpreted as May 13th 2022, 15:30:00h _UTC_
   *   - `"yyyy-MM-dd[T]HH:mm:ss[±]hh:mm"` for a timestamp with an arbitrary UTC offset: e.g. `"2022-05-13T15:30:00+03:00"` for 15:30 Djibouti time (with a 03:00h UTC offset) will be interpreted as May 13th 2022, 15:30:00h _Djibouti time_, which is 12:30 _UTC_
   */
  DateInput: { input: any; output: any; }
  /**
   * A string representing a specific point in time in the [ISO Format](https://en.wikipedia.org/wiki/ISO_8601) `"yyyy-MM-dd[T]HH:mm:ss[±]hh:mm"` containing the information in which timezone this date is happening.
   *
   *   For example `"2022-03-15T20:15:00+01:00"` would denote the _15th of March 2022, 20:15:00 local time in a timezone offset by 1 hour from UTC_. (e.g. Vienna)
   */
  DateOutput: { input: any; output: any; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: { input: Date | string; output: string; }
  /** A file type descriptor. See [Image Media Types](https://www.iana.org/assignments/media-types/media-types.xhtml#image) */
  MimeType: { input: any; output: any; }
  /** A URL */
  URL: { input: string; output: string; }
};

/**
 * An `Activity` is a single sport event happening at a specific time.
 *
 *   `Activities` can be individually bookable units (e.g. _Classes_) or part of a larger bookable `ActivityGroups` (e.g. _Courses_ or _Workshops_)
 *
 */
export type Activity = Participatable & {
  __typename: 'Activity';
  /** The `ActivityGroup` of this `Activity` */
  activityGroup: ActivityGroup;
  /**
   * Information on _whether_ and _how_ this `Activity` is bookable.
   *
   *   If this field is `null` this `Activity` is _not_ bookable.
   *   This can have multiple reasons:
   *   - This `Activity` is not itself an individually _bookable unit_, but just a part of an `ActivityGroup` which has to be booked as a whole.
   *   - This `Activity` is _archived_ or _cancelled_
   *   - The `PublicationState` of its `ActivityGroup` is not `ACTIVE`
   *
   *   If this field is _not_ `null` this `Activity` is generally bookable.
   *   Note that further restriction like a registration window or a limitation of spots can still apply.
   */
  bookable: Maybe<Bookable>;
  detailsPageURL: Maybe<Scalars['URL']['output']>;
  /** The end of this `Activity` provided in the `DateOutput` format */
  end: Scalars['DateOutput']['output'];
  /** Whether this `Activity` has an online stream */
  hasOnlineStream: Scalars['Boolean']['output'];
  /** The universally unique identifier for this `Activity` */
  id: Scalars['ID']['output'];
  /**
   * Whether this `Activity` is _archived_.
   *   An `Activity` can be _archived_ if the `ActivityGroup` containing it was archived or deleted as a whole or the individual `Activity` itself was deleted.
   */
  isArchived: Scalars['Boolean']['output'];
  /** Whether this `Activity` is cancelled */
  isCancelled: Scalars['Boolean']['output'];
  level: Maybe<ActivityDifficultyLevel>;
  /**
   * Information on _whether_ and _how_ this `Activity` has limited spots for participants.
   *
   *   If This field is `null` this individual `Activity` is _not_ limited
   *   This can have multiple reasons:
   *   - This `Activity` is part of an `ActivityGroup` which is limited as a whole, like a _Course_
   *   - This `Activity` allows for unlimited participants, like e.g. an online class
   *
   *   If this field is _not_ `null` this `Activity` has a limited number of spots for participants.
   *   This can be the case for individually bookable `Activities` of e.g. a _Class_ or also for the `Activities` in an `ActivityGroup` like e.g. a _Workshop_ using [Tickets](https://help.eversportsmanager.com/ticket-system-for-workshops-courses-and-events-eversports-help-center).
   */
  limited: Maybe<Limited>;
  /**
   * The physical location at which this `Activity` will happen.
   *
   *   Note that e.g. a _Class_ "Yoga in the Park" might happen at a location different from the `Location` of the `Venue`.
   */
  location: Maybe<Location>;
  /**
   * A name for this specific `Activity`.
   *     Note that not all `Activities` have a specific name. If the name is `null` you can infer its name from the name of the `ActivityGroup`.
   *
   *     E.g. an `ActivityGroup` called “Morning Yoga” might have `Activities` without specific names, all `Activities` are generic “Morning Yoga” `Activities`.
   *     But an `ActivityGroup` called “Beginners Course” might contain `Activities` individually named “Week 1 - Basics”, “Week 2 - Breathing”,…
   */
  name: Maybe<Scalars['String']['output']>;
  /** The `Room` this `Activity` happens in */
  room: Maybe<Room>;
  /** The start of this `Activity` provided in the `DateOutput` format */
  start: Scalars['DateOutput']['output'];
  /** The `Teacher` teaching this `Activity` */
  teacher: Maybe<Teacher>;
};

/** An `ActivityCategory` */
export type ActivityCategory = {
  __typename: 'ActivityCategory';
  /** A color chosen for this `ActivityCategory` to visually group different `Activities` or `ActivityGroups` in a schedule for example. */
  color: Maybe<Scalars['Color']['output']>;
  /** The universally unique identifier for this `ActivityCategory` */
  id: Scalars['ID']['output'];
  /** The name of this `ActivityCategory` */
  name: Scalars['String']['output'];
  /** The `Venue` providing this `ActivityCategory` */
  venue: Venue;
};

/** A _paginated_ result set of "ActivityCategory" items following the [GraphQL Cursor Connections Specification](https://relay.dev/graphql/connections.htm) */
export type ActivityCategoryConnection = {
  __typename: 'ActivityCategoryConnection';
  /** The `Edges` "ActivityCategory" items */
  edges: Array<ActivityCategoryEdge>;
  /** The actual "ActivityCategory" items */
  nodes: Array<ActivityCategory>;
  /** Meta-Information about the paginated result */
  pageInfo: PageInfo;
};

export type ActivityCategoryEdge = {
  __typename: 'ActivityCategoryEdge';
  cursor: Scalars['Cursor']['output'];
  node: ActivityCategory;
};

/** A filter option for selecting a "ActivityCategory" item. */
export type ActivityCategoryFilterOption = {
  __typename: 'ActivityCategoryFilterOption';
  /** Indicates whether the option is selected by default */
  isSelected: Scalars['Boolean']['output'];
  /** The value of the "ActivityCategory" item. */
  value: ActivityCategory;
};

/** A _paginated_ result set of "ActivityCategoryFilterOption" items following the [GraphQL Cursor Connections Specification](https://relay.dev/graphql/connections.htm) */
export type ActivityCategoryFilterOptionConnection = {
  __typename: 'ActivityCategoryFilterOptionConnection';
  /** The `Edges` "ActivityCategoryFilterOption" items */
  edges: Array<ActivityCategoryFilterOptionEdge>;
  /** The actual "ActivityCategoryFilterOption" items */
  nodes: Array<ActivityCategoryFilterOption>;
  /** Meta-Information about the paginated result */
  pageInfo: PageInfo;
};

export type ActivityCategoryFilterOptionEdge = {
  __typename: 'ActivityCategoryFilterOptionEdge';
  cursor: Scalars['Cursor']['output'];
  node: ActivityCategoryFilterOption;
};

/** A _paginated_ result set of "Activity" items following the [GraphQL Cursor Connections Specification](https://relay.dev/graphql/connections.htm) */
export type ActivityConnection = {
  __typename: 'ActivityConnection';
  /** The `Edges` "Activity" items */
  edges: Array<ActivityEdge>;
  /** The actual "Activity" items */
  nodes: Array<Activity>;
  /** Meta-Information about the paginated result */
  pageInfo: PageInfo;
};

export enum ActivityDifficultyLevel {
  ALL = 'ALL',
  BEGINNER = 'BEGINNER',
  INTERMEDIATE = 'INTERMEDIATE',
  PROFESSIONAL = 'PROFESSIONAL'
}

export type ActivityEdge = {
  __typename: 'ActivityEdge';
  cursor: Scalars['Cursor']['output'];
  node: Activity;
};

/**
 * An `ActivityGroup` is a group or series typically consisting of multiple `Activities`.
 *
 *   `ActivityGroup` can be bookable units as a whole (e.g. a _Course_) or just a series of individually bookable `Activities` (e.g. a _Class_)
 */
export type ActivityGroup = Participatable & {
  __typename: 'ActivityGroup';
  /** A _paginated_ list of `Activities` of this `ActivityGroup` */
  activities: ActivityConnection;
  bookable: Maybe<Bookable>;
  /** The `ActivityCategory` */
  category: ActivityCategory;
  /** A color chosen for this `ActivityGroup` to visually group different `Activities` or `ActivityGroups` in a schedule for example. */
  color: Maybe<Scalars['Color']['output']>;
  /** A free text describing this `ActivityGroup` */
  description: FormattedText;
  detailsPageURL: Maybe<Scalars['URL']['output']>;
  /** The end of this `Activity Group Sessions` provided in the `DateOutput` format */
  end: Maybe<Scalars['DateOutput']['output']>;
  /** Whether this `Activity Group Sessions` has an online stream */
  hasOnlineStream: Maybe<Scalars['Boolean']['output']>;
  /** The universally unique identifier for this `ActivityGroup` */
  id: Scalars['ID']['output'];
  /**
   * A _paginated_ list of `Images` of this `ActivityGroup`
   * @deprecated We will now use images with specified sizes. Use the `ImageV2` type for the images instead.
   */
  images: ImageConnection;
  /** The title image of this `Recording` */
  imagesV2: Maybe<ImageV2Connection>;
  level: Maybe<ActivityDifficultyLevel>;
  limited: Maybe<Limited>;
  /** The name of this `ActivityGroup` */
  name: Scalars['String']['output'];
  /** The `PublicationState` of this `ActivityGroup` */
  publicationState: PublicationState;
  /** The `Activity Group Sessions` count */
  sessionCount: Scalars['Int']['output'];
  /** The `Sport` of this `ActivityGroup` */
  sport: Maybe<Sport>;
  /** The start of this `Activity Group Sessions` provided in the `DateOutput` format */
  start: Maybe<Scalars['DateOutput']['output']>;
  /** The `ActivityGroupType` chosen for this `ActivityGroup` */
  type: ActivityGroupType;
  /** The `Venue` providing this `ActivityGroup` */
  venue: Venue;
};


/**
 * An `ActivityGroup` is a group or series typically consisting of multiple `Activities`.
 *
 *   `ActivityGroup` can be bookable units as a whole (e.g. a _Course_) or just a series of individually bookable `Activities` (e.g. a _Class_)
 */
export type ActivityGroupActivitiesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * An `ActivityGroup` is a group or series typically consisting of multiple `Activities`.
 *
 *   `ActivityGroup` can be bookable units as a whole (e.g. a _Course_) or just a series of individually bookable `Activities` (e.g. a _Class_)
 */
export type ActivityGroupImagesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * An `ActivityGroup` is a group or series typically consisting of multiple `Activities`.
 *
 *   `ActivityGroup` can be bookable units as a whole (e.g. a _Course_) or just a series of individually bookable `Activities` (e.g. a _Class_)
 */
export type ActivityGroupImagesV2Args = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

/** A _paginated_ result set of "ActivityGroup" items following the [GraphQL Cursor Connections Specification](https://relay.dev/graphql/connections.htm) */
export type ActivityGroupConnection = {
  __typename: 'ActivityGroupConnection';
  /** The `Edges` "ActivityGroup" items */
  edges: Array<ActivityGroupEdge>;
  /** The actual "ActivityGroup" items */
  nodes: Array<ActivityGroup>;
  /** Meta-Information about the paginated result */
  pageInfo: PageInfo;
};

export type ActivityGroupEdge = {
  __typename: 'ActivityGroupEdge';
  cursor: Scalars['Cursor']['output'];
  node: ActivityGroup;
};

/** A classification into certain common categories of activities */
export enum ActivityGroupType {
  CAMP = 'CAMP',
  CLASS = 'CLASS',
  COURSE = 'COURSE',
  EDUCATION = 'EDUCATION',
  EVENT = 'EVENT',
  OPEN_TRAINING = 'OPEN_TRAINING',
  OTHER = 'OTHER',
  RETREAT = 'RETREAT',
  TRAINING = 'TRAINING',
  WORKSHOP = 'WORKSHOP'
}

export enum ActivitySpotLimitDisplayType {
  ACTIVITY_SPOT_LIMIT_DISPLAY_TYPE_FREE_SPOTS_COUNT = 'ACTIVITY_SPOT_LIMIT_DISPLAY_TYPE_FREE_SPOTS_COUNT',
  ACTIVITY_SPOT_LIMIT_DISPLAY_TYPE_PARTICIPANTS_COUNT = 'ACTIVITY_SPOT_LIMIT_DISPLAY_TYPE_PARTICIPANTS_COUNT'
}

/** A `Bookable` object contains information about the booking of an `Activity` or  `ActivityGroup` */
export type Bookable = {
  __typename: 'Bookable';
  /**
   * The latest possible time at which a booking is allowed.
   *     If `bookableWindowEnd` is `null` there is no limitation.
   *     This means a booking is possible until the end of the `Activity` or last `Activity` within an `ActivityGroup`.
   */
  bookableWindowEnd: Maybe<Scalars['DateOutput']['output']>;
  /**
   * The earliest possible time at which a booking is allowed.
   *     If `bookableWindowStart` is `null` there is no limitation.
   */
  bookableWindowStart: Maybe<Scalars['DateOutput']['output']>;
  /** The time until which a booking can be cancelled without incurring charges. */
  cancellationDeadline: Scalars['DateOutput']['output'];
  /** A URL linking to the Eversports Checkout for this item. Customers can login and choose their existing products or purchase a new product to participate. */
  checkoutURL: Scalars['URL']['output'];
};

export type Card = ProductInterface & {
  __typename: 'Card';
  /** This is a special offer reserved for new customers */
  allowedOnlyForNewCustomers: Scalars['Boolean']['output'];
  cardType: CardType;
  detailsPageURL: Scalars['URL']['output'];
  id: Scalars['ID']['output'];
  /** This is a trial offer for people new to the studio */
  isTrialCard: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  price: MonetaryValue;
  purchaseInformation: Maybe<PurchaseInformation>;
  usages: Array<UsageLimit>;
  validity: Maybe<TimePeriod>;
};


export type CardDetailsPageUrlArgs = {
  purchaseAtVenueId: Scalars['ID']['input'];
};

export enum CardType {
  CARD_TYPE_BLOCK = 'CARD_TYPE_BLOCK',
  CARD_TYPE_TIME = 'CARD_TYPE_TIME'
}

/** A `Company` is a legal entity comprising one or more `Venues` */
export type Company = {
  __typename: 'Company';
  /** The universally unique identifier for this `Company` */
  id: Scalars['ID']['output'];
  /** The name of this `Company` */
  name: Scalars['String']['output'];
  /**
   * A _paginated_ list of `Venues` of this `Company`.
   *
   *     Note that only `Venues` are included, which are activated for your integration.
   */
  venues: VenueConnection;
};


/** A `Company` is a legal entity comprising one or more `Venues` */
export type CompanyVenuesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

/** A pair of decimal degrees representing a point on earths surface */
export type Coordinates = {
  __typename: 'Coordinates';
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

/** A freetext possibly containing markup like lists, paragraphs, emphasis etc. */
export type FormattedText = {
  __typename: 'FormattedText';
  /** An HTML representation of the description containing semantic HTML tags like <p>, <li> or <b> and HTML entities like &amp; to represent a & sign. */
  html: Scalars['String']['output'];
  /** A plain text representation of the formatted text using plain text characters like e.g. newline (`\n`) to replace a paragraph. */
  plainText: Scalars['String']['output'];
};

export enum Gender {
  DIVERSE = 'DIVERSE',
  FEMALE = 'FEMALE',
  MALE = 'MALE'
}

export type Image = {
  __typename: 'Image';
  /** An optional description of this `Image`. */
  description: Maybe<Scalars['String']['output']>;
  /** The type of the `Image`. E.g. `image/png`, `image/jpeg` or `image/gif`. */
  mimeType: Scalars['MimeType']['output'];
  /** A URL linking to the `Image`. */
  url: Scalars['URL']['output'];
};

/** A _paginated_ result set of "Image" items following the [GraphQL Cursor Connections Specification](https://relay.dev/graphql/connections.htm) */
export type ImageConnection = {
  __typename: 'ImageConnection';
  /** The `Edges` "Image" items */
  edges: Array<ImageEdge>;
  /** The actual "Image" items */
  nodes: Array<Image>;
  /** Meta-Information about the paginated result */
  pageInfo: PageInfo;
};

export type ImageEdge = {
  __typename: 'ImageEdge';
  cursor: Scalars['Cursor']['output'];
  node: Image;
};

export enum ImageSize {
  LARGE = 'LARGE',
  LIST_BASIC = 'LIST_BASIC',
  LIST_PREMIUM = 'LIST_PREMIUM',
  MEDIUM = 'MEDIUM',
  ORIGINAL = 'ORIGINAL',
  SMALL = 'SMALL',
  XX_LARGE = 'XX_LARGE',
  X_LARGE = 'X_LARGE',
  X_SMALL = 'X_SMALL'
}

export type ImageV2 = {
  __typename: 'ImageV2';
  id: Scalars['ID']['output'];
  url: Maybe<Scalars['URL']['output']>;
};


export type ImageV2UrlArgs = {
  size: ImageSize;
};

/** A _paginated_ result set of "ImageV2" items following the [GraphQL Cursor Connections Specification](https://relay.dev/graphql/connections.htm) */
export type ImageV2Connection = {
  __typename: 'ImageV2Connection';
  /** The `Edges` "ImageV2" items */
  edges: Array<ImageV2Edge>;
  /** The actual "ImageV2" items */
  nodes: Array<ImageV2>;
  /** Meta-Information about the paginated result */
  pageInfo: PageInfo;
};

export type ImageV2Edge = {
  __typename: 'ImageV2Edge';
  cursor: Scalars['Cursor']['output'];
  node: ImageV2;
};

export type Interval = {
  __typename: 'Interval';
  unit: IntervalUnit;
  value: Scalars['Int']['output'];
};

export enum IntervalUnit {
  INTERVAL_UNIT_DAYS = 'INTERVAL_UNIT_DAYS',
  INTERVAL_UNIT_HOURS = 'INTERVAL_UNIT_HOURS',
  INTERVAL_UNIT_MINUTE = 'INTERVAL_UNIT_MINUTE',
  INTERVAL_UNIT_MONTHS = 'INTERVAL_UNIT_MONTHS',
  INTERVAL_UNIT_WEEKS = 'INTERVAL_UNIT_WEEKS',
  INTERVAL_UNIT_YEARS = 'INTERVAL_UNIT_YEARS'
}

export type Limited = {
  __typename: 'Limited';
  freeSpots: Scalars['Int']['output'];
  totalSpots: Scalars['Int']['output'];
};

/** A physical location */
export type Location = {
  __typename: 'Location';
  /** The name of the city of this `Location` */
  city: Maybe<Scalars['String']['output']>;
  /** The coordinates of this `Location` */
  coordinates: Maybe<Coordinates>;
  /**
   * The country of this `Location` represented by its 2 letter country code as defined in [ISO 3166](https://en.wikipedia.org/wiki/List_of_ISO_3166_country_codes)
   *
   * For example "DE" or "AT".
   */
  country: Maybe<Scalars['String']['output']>;
  /** An optional name for this `Location` */
  name: Maybe<Scalars['String']['output']>;
  /** An street name of this `Location` */
  street: Maybe<Scalars['String']['output']>;
  /** Whether this `Location` is indoor or outdoor */
  type: LocationType;
  /** The ZIP code of this `Location` */
  zip: Maybe<Scalars['String']['output']>;
};

/** An indication of whether a `Location` is indoor our outdoor */
export enum LocationType {
  LOCATION_TYPE_INDOOR = 'LOCATION_TYPE_INDOOR',
  LOCATION_TYPE_OUTDOOR = 'LOCATION_TYPE_OUTDOOR'
}

export type Membership = ProductInterface & {
  __typename: 'Membership';
  conditions: Maybe<Scalars['String']['output']>;
  detailsPageURL: Scalars['URL']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  paymentPlan: PaymentPlan;
  purchaseInformation: Maybe<PurchaseInformation>;
  runtime: Runtime;
  usages: Array<UsageLimit>;
};


export type MembershipDetailsPageUrlArgs = {
  purchaseAtVenueId: Scalars['ID']['input'];
};

/**
 * This type represents any kind of monetary value, such as price or balance.
 * It is a combination of a `value` in cents, and a `currency` as an
 * [ISO 4217 Currency Code](https://www.xe.com/iso4217.php).
 *
 * ### Example
 *
 * A price of `1, 99 €` will be represented as
 *
 * ```
 * {
 *     value: 199,
 *     currency: "EUR"
 *   }
 * ```
 */
export type MonetaryValue = {
  __typename: 'MonetaryValue';
  currency: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export type PageInfo = {
  __typename: 'PageInfo';
  /** The `Cursor` of the last item in this page. You can use it as the `after` input argument to retrieve the next page. */
  endCursor: Maybe<Scalars['Cursor']['output']>;
  /** Whether there are more results after the current page */
  hasNextPage: Scalars['Boolean']['output'];
  /** Whether there are results before the current page */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** The `Cursor` of the first item in this page. You can use it as the `before` input argument to retrieve the previous page. */
  startCursor: Maybe<Scalars['Cursor']['output']>;
};

/** The `Participatable` interface is shared by `Activity` and `ActivityGroup` and contains information about participating in them */
export type Participatable = {
  /**
   * Information on _whether_ and _how_ a `Participatable` is bookable.
   *
   *   If this field is `null` this `Participatable` is _not_ bookable.
   *
   *   If this field is _not_ `null` this `Participatable` is generally bookable.
   *   Note that further restriction like a registration window or a limitation of spots can still apply.
   */
  bookable: Maybe<Bookable>;
  detailsPageURL: Maybe<Scalars['URL']['output']>;
  level: Maybe<ActivityDifficultyLevel>;
  /**
   * Information on _whether_ and _how_ a `Participatable` has limited capacity.
   *
   *   If this field is `null` this `Participatable` is _not_ limited.
   *   If this field is _not_ `null` this `Participatable` has a limited capacity.
   */
  limited: Maybe<Limited>;
};

export type PaymentPlan = {
  __typename: 'PaymentPlan';
  initial: Maybe<MonetaryValue>;
  interval: Interval;
  offset: Maybe<Scalars['Int']['output']>;
  promotion: Maybe<Promotion>;
  recurring: MonetaryValue;
};

export enum PeriodStartType {
  VALIDITY_START_TYPE_DATE = 'VALIDITY_START_TYPE_DATE',
  VALIDITY_START_TYPE_FIRST_BOOKING = 'VALIDITY_START_TYPE_FIRST_BOOKING',
  VALIDITY_START_TYPE_PURCHASE_DATE = 'VALIDITY_START_TYPE_PURCHASE_DATE'
}

export type Product = Card | Membership;

/** A _paginated_ result set of "Product" items following the [GraphQL Cursor Connections Specification](https://relay.dev/graphql/connections.htm) */
export type ProductConnection = {
  __typename: 'ProductConnection';
  /** The `Edges` "Product" items */
  edges: Array<ProductEdge>;
  /** The actual "Product" items */
  nodes: Array<Product>;
  /** Meta-Information about the paginated result */
  pageInfo: PageInfo;
};

export type ProductEdge = {
  __typename: 'ProductEdge';
  cursor: Scalars['Cursor']['output'];
  node: Product;
};

export type ProductGroup = {
  __typename: 'ProductGroup';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  priority: Scalars['Int']['output'];
  /** Retrieve a _paginated_ list of all `Products` linked to the `ProductGroup` */
  products: ProductConnection;
};


export type ProductGroupProductsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  purchasableAtVenueId?: InputMaybe<Scalars['ID']['input']>;
};

/** A _paginated_ result set of "ProductGroup" items following the [GraphQL Cursor Connections Specification](https://relay.dev/graphql/connections.htm) */
export type ProductGroupConnection = {
  __typename: 'ProductGroupConnection';
  /** The `Edges` "ProductGroup" items */
  edges: Array<ProductGroupEdge>;
  /** The actual "ProductGroup" items */
  nodes: Array<ProductGroup>;
  /** Meta-Information about the paginated result */
  pageInfo: PageInfo;
};

export type ProductGroupEdge = {
  __typename: 'ProductGroupEdge';
  cursor: Scalars['Cursor']['output'];
  node: ProductGroup;
};

export type ProductInterface = {
  detailsPageURL: Scalars['URL']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  purchaseInformation: Maybe<PurchaseInformation>;
};


export type ProductInterfaceDetailsPageUrlArgs = {
  purchaseAtVenueId: Scalars['ID']['input'];
};

export type Promotion = {
  __typename: 'Promotion';
  period: Interval;
  price: MonetaryValue;
};

/**
 * A status indicating whether an `ActivityGroup` is publicly bookable, visible only, hidden or archived:
 * - ACTIVE  (This ActivityGroup or the Activities it contains are active and bookable for the public)
 * - VIEW_ONLY  (This ActivityGroup can not be booked publicly, but is still visible to the public)
 * - HIDDEN  (This ActivityGroup is set to be hidden from the public. It might be for internal use only, not yet public or hidden after it was cancelled)
 * - ARCHIVED  (This ActivityGroup is archived. It or its constituent Activities can not be booked.)
 *
 */
export enum PublicationState {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
  HIDDEN = 'HIDDEN',
  VIEW_ONLY = 'VIEW_ONLY'
}

export type PurchaseInformation = {
  __typename: 'PurchaseInformation';
  /** A URL linking to the Eversports Checkout for this item. Customers can login and choose their existing products or purchase a new product to participate. */
  checkoutURL: Scalars['URL']['output'];
  description: Maybe<Scalars['String']['output']>;
};


export type PurchaseInformationCheckoutUrlArgs = {
  purchaseAtVenueId: Scalars['ID']['input'];
};

export type Query = {
  __typename: 'Query';
  widget: Widget;
};


export type QueryWidgetArgs = {
  id: Scalars['ID']['input'];
};

export type Recording = {
  __typename: 'Recording';
  /** The URL to the details page of this `Recording` */
  detailsPageURL: Scalars['URL']['output'];
  duration: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  /** The title image of this `Recording` */
  image: Maybe<ImageV2>;
  /** The `language` of this `Recording` */
  language: Maybe<RecordingSupportedLanguage>;
  level: Maybe<RecordingDifficultyLevel>;
  name: Scalars['String']['output'];
  recordingEndDate: Maybe<Scalars['DateOutput']['output']>;
  recordingStartDate: Maybe<Scalars['DateOutput']['output']>;
  /** The `Sport` of this `Recording` */
  sport: Maybe<Sport>;
  /** The `Teacher` teaching this `Recording` */
  teacher: Maybe<Teacher>;
  /** The `Venue` providing this `Recording` */
  venue: Venue;
};

export type RecordingCategory = {
  __typename: 'RecordingCategory';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** Retrieve a _paginated_ list of all `Recordings` linked to the `Recording Categories` */
  recordings: RecordingConnection;
};


export type RecordingCategoryRecordingsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  currentlyAvailable?: InputMaybe<Scalars['Boolean']['input']>;
  difficultyLevels?: InputMaybe<Array<RecordingDifficultyLevel>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  languages?: InputMaybe<Array<RecordingSupportedLanguage>>;
  maxDuration?: InputMaybe<Scalars['Int']['input']>;
  minDuration?: InputMaybe<Scalars['Int']['input']>;
  sportIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  teacherIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** A _paginated_ result set of "RecordingCategory" items following the [GraphQL Cursor Connections Specification](https://relay.dev/graphql/connections.htm) */
export type RecordingCategoryConnection = {
  __typename: 'RecordingCategoryConnection';
  /** The `Edges` "RecordingCategory" items */
  edges: Array<RecordingCategoryEdge>;
  /** The actual "RecordingCategory" items */
  nodes: Array<RecordingCategory>;
  /** Meta-Information about the paginated result */
  pageInfo: PageInfo;
};

export type RecordingCategoryEdge = {
  __typename: 'RecordingCategoryEdge';
  cursor: Scalars['Cursor']['output'];
  node: RecordingCategory;
};

/** A _paginated_ result set of "Recording" items following the [GraphQL Cursor Connections Specification](https://relay.dev/graphql/connections.htm) */
export type RecordingConnection = {
  __typename: 'RecordingConnection';
  /** The `Edges` "Recording" items */
  edges: Array<RecordingEdge>;
  /** The actual "Recording" items */
  nodes: Array<Recording>;
  /** Meta-Information about the paginated result */
  pageInfo: PageInfo;
};

export enum RecordingDifficultyLevel {
  ALL = 'ALL',
  BEGINNER = 'BEGINNER',
  INTERMEDIATE = 'INTERMEDIATE',
  PROFESSIONAL = 'PROFESSIONAL'
}

/** A filter option for selecting a "RecordingDifficultyLevel" item. */
export type RecordingDifficultyLevelFilterOption = {
  __typename: 'RecordingDifficultyLevelFilterOption';
  /** Indicates whether the option is selected by default */
  isSelected: Scalars['Boolean']['output'];
  /** The value of the "RecordingDifficultyLevel" item. */
  value: RecordingDifficultyLevel;
};

export type RecordingEdge = {
  __typename: 'RecordingEdge';
  cursor: Scalars['Cursor']['output'];
  node: Recording;
};

export enum RecordingSupportedLanguage {
  DUTCH = 'DUTCH',
  ENGLISH = 'ENGLISH',
  FRENCH = 'FRENCH',
  GERMAN = 'GERMAN',
  ITALIAN = 'ITALIAN',
  SPANISH = 'SPANISH'
}

/** A filter option for selecting a "RecordingSupportedLanguage" item. */
export type RecordingSupportedLanguageFilterOption = {
  __typename: 'RecordingSupportedLanguageFilterOption';
  /** Indicates whether the option is selected by default */
  isSelected: Scalars['Boolean']['output'];
  /** The value of the "RecordingSupportedLanguage" item. */
  value: RecordingSupportedLanguage;
};

export type Renewal = {
  __typename: 'Renewal';
  interval: Interval;
  termination: Interval;
};

export type Repeating = {
  __typename: 'Repeating';
  interval: Interval;
  isTransferable: Scalars['Boolean']['output'];
};

export type Room = {
  __typename: 'Room';
  /** The universally unique identifier for this `Room` */
  id: Scalars['ID']['output'];
  /** The name of this `Room` */
  name: Scalars['String']['output'];
};

export type Runtime = {
  __typename: 'Runtime';
  initial: Interval;
  pausable: Scalars['Boolean']['output'];
  renewal: Maybe<Renewal>;
};

export type Sport = {
  __typename: 'Sport';
  /** The universally unique identifier for this `Sport` */
  id: Scalars['ID']['output'];
  /** The i18nized `name` of this `Sport` */
  name: Scalars['String']['output'];
};

/** A _paginated_ result set of "Sport" items following the [GraphQL Cursor Connections Specification](https://relay.dev/graphql/connections.htm) */
export type SportConnection = {
  __typename: 'SportConnection';
  /** The `Edges` "Sport" items */
  edges: Array<SportEdge>;
  /** The actual "Sport" items */
  nodes: Array<Sport>;
  /** Meta-Information about the paginated result */
  pageInfo: PageInfo;
};

export type SportEdge = {
  __typename: 'SportEdge';
  cursor: Scalars['Cursor']['output'];
  node: Sport;
};

/** A filter option for selecting a "Sport" item. */
export type SportFilterOption = {
  __typename: 'SportFilterOption';
  /** Indicates whether the option is selected by default */
  isSelected: Scalars['Boolean']['output'];
  /** The value of the "Sport" item. */
  value: Sport;
};

/** A _paginated_ result set of "SportFilterOption" items following the [GraphQL Cursor Connections Specification](https://relay.dev/graphql/connections.htm) */
export type SportFilterOptionConnection = {
  __typename: 'SportFilterOptionConnection';
  /** The `Edges` "SportFilterOption" items */
  edges: Array<SportFilterOptionEdge>;
  /** The actual "SportFilterOption" items */
  nodes: Array<SportFilterOption>;
  /** Meta-Information about the paginated result */
  pageInfo: PageInfo;
};

export type SportFilterOptionEdge = {
  __typename: 'SportFilterOptionEdge';
  cursor: Scalars['Cursor']['output'];
  node: SportFilterOption;
};

export type Teacher = {
  __typename: 'Teacher';
  /** A descriptive text about this `Teacher` */
  description: Maybe<FormattedText>;
  /** A free text about the education of this `Teacher` */
  education: Maybe<FormattedText>;
  /** The gender of this `Teacher` */
  gender: Maybe<Gender>;
  /** The universally unique identifier for this `Teacher` */
  id: Scalars['ID']['output'];
  /**
   * The profile picture of this `Teacher`
   * @deprecated We will now use images with specified sizes. Use the `ImageV2` type for the images instead.
   */
  image: Maybe<Image>;
  /** The profile picture of this `Teacher` */
  imageV2: Maybe<ImageV2>;
  /** The name of this `Teacher` */
  name: Scalars['String']['output'];
};

/** A _paginated_ result set of "Teacher" items following the [GraphQL Cursor Connections Specification](https://relay.dev/graphql/connections.htm) */
export type TeacherConnection = {
  __typename: 'TeacherConnection';
  /** The `Edges` "Teacher" items */
  edges: Array<TeacherEdge>;
  /** The actual "Teacher" items */
  nodes: Array<Teacher>;
  /** Meta-Information about the paginated result */
  pageInfo: PageInfo;
};

export type TeacherEdge = {
  __typename: 'TeacherEdge';
  cursor: Scalars['Cursor']['output'];
  node: Teacher;
};

/** A filter option for selecting a "Teacher" item. */
export type TeacherFilterOption = {
  __typename: 'TeacherFilterOption';
  /** Indicates whether the option is selected by default */
  isSelected: Scalars['Boolean']['output'];
  /** The value of the "Teacher" item. */
  value: Teacher;
};

/** A _paginated_ result set of "TeacherFilterOption" items following the [GraphQL Cursor Connections Specification](https://relay.dev/graphql/connections.htm) */
export type TeacherFilterOptionConnection = {
  __typename: 'TeacherFilterOptionConnection';
  /** The `Edges` "TeacherFilterOption" items */
  edges: Array<TeacherFilterOptionEdge>;
  /** The actual "TeacherFilterOption" items */
  nodes: Array<TeacherFilterOption>;
  /** Meta-Information about the paginated result */
  pageInfo: PageInfo;
};

export type TeacherFilterOptionEdge = {
  __typename: 'TeacherFilterOptionEdge';
  cursor: Scalars['Cursor']['output'];
  node: TeacherFilterOption;
};

export type TimePeriod = {
  __typename: 'TimePeriod';
  duration: Interval;
  /** The start date is only valid when the `startType` is `VALIDITY_START_TYPE_DATE`. */
  startDate: Maybe<Scalars['Date']['output']>;
  startType: PeriodStartType;
};

export type TimeRange = {
  __typename: 'TimeRange';
  end: Maybe<Scalars['DateTime']['output']>;
  start: Maybe<Scalars['DateTime']['output']>;
};

export type TimeRangeInput = {
  end?: InputMaybe<Scalars['DateInput']['input']>;
  start?: InputMaybe<Scalars['DateInput']['input']>;
};

export type UsageLimit = {
  __typename: 'UsageLimit';
  currency: Maybe<Scalars['String']['output']>;
  repeating: Maybe<Repeating>;
  type: UsageLimitType;
  unit: UsageLimitUnit;
  usageLimit: Scalars['Float']['output'];
};

/**
 *
 *   - `TOTAL` means `value` is to be interpreted as a limit which applies to the entire card over the entirity of its lifetime.
 *   - `REPEATING` means `value` is to be interpreted as a limit which applies on an Interval Basis, where `repeating` provides information on this interval.
 *   - `PER BOOKING` means `value` is to be interpreted as a limit which applies on the basis of a single booking, like no more than 1.5 hours per booking.
 *
 */
export enum UsageLimitType {
  USAGE_LIMIT_TYPE_PER_BOOKING = 'USAGE_LIMIT_TYPE_PER_BOOKING',
  USAGE_LIMIT_TYPE_REPEATING = 'USAGE_LIMIT_TYPE_REPEATING',
  USAGE_LIMIT_TYPE_TOTAL = 'USAGE_LIMIT_TYPE_TOTAL'
}

/**
 *
 *   - `HOURS` means `value` is given in hours. E.g. a limit of 5 hours per week.
 *   - `MONETARY` means `value` is given as financial value, where `currency` provides the currency. E.g. a card allowing 100 € worth of bookings to be made.
 *   - `UNITS` means `value` is given as generic units, usually equal to bookings of activities, however some activities may cost more units than others.
 *
 */
export enum UsageLimitUnit {
  USAGE_LIMIT_UNIT_HOURS = 'USAGE_LIMIT_UNIT_HOURS',
  USAGE_LIMIT_UNIT_MONETARY = 'USAGE_LIMIT_UNIT_MONETARY',
  USAGE_LIMIT_UNIT_UNITS = 'USAGE_LIMIT_UNIT_UNITS'
}

/** A `Venue` is a provider of `Activities`. This is usually a physical location like a _Studio_ or _Gym_. */
export type Venue = {
  __typename: 'Venue';
  /** The `Company` this `Venue` belongs to */
  company: Company;
  /** The universally unique identifier for this `Venue` */
  id: Scalars['ID']['output'];
  /** A _paginated_ list of `Images` of this `Venue` */
  images: ImageConnection;
  /**
   * The physical location of this `Venue`.
   *
   *     Note that not all `Activities` of a `Venue` are necessarily also happening at this same `Location`. E.g. a `Venue` might offer _"Yoga in the Park"_ at a different `Location` as indicated by  `Activity.location`.
   */
  location: Location;
  /** The name of this `Venue` */
  name: Scalars['String']['output'];
  /**
   * The shortId of this `Venue`.
   * @deprecated The `shortId` field is deprecated and will be removed in a future version.
   */
  shortId: Scalars['String']['output'];
  /** A _paginated_ list of `Teachers` of this `Venue` */
  teachers: TeacherConnection;
};


/** A `Venue` is a provider of `Activities`. This is usually a physical location like a _Studio_ or _Gym_. */
export type VenueImagesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


/** A `Venue` is a provider of `Activities`. This is usually a physical location like a _Studio_ or _Gym_. */
export type VenueTeachersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};

/** A _paginated_ result set of "Venue" items following the [GraphQL Cursor Connections Specification](https://relay.dev/graphql/connections.htm) */
export type VenueConnection = {
  __typename: 'VenueConnection';
  /** The `Edges` "Venue" items */
  edges: Array<VenueEdge>;
  /** The actual "Venue" items */
  nodes: Array<Venue>;
  /** Meta-Information about the paginated result */
  pageInfo: PageInfo;
};

export type VenueEdge = {
  __typename: 'VenueEdge';
  cursor: Scalars['Cursor']['output'];
  node: Venue;
};

export type Widget = WidgetActivityGroups | WidgetActivitySchedule | WidgetPrices | WidgetVideos;

export type WidgetActivityGroups = WidgetInterface & {
  __typename: 'WidgetActivityGroups';
  /** Retrieve a _paginated_ list of all `ActivityGroups` enabled for the `Widget` */
  activityGroups: ActivityGroupConnection;
  company: Company;
  defaultTimeRange: TimeRange;
  id: Scalars['ID']['output'];
  marketplaceURL: Scalars['URL']['output'];
  settings: WidgetActivityGroupsSettings;
  /** Retrieve a _paginated_ list of all `Venues` that are activated for your integration */
  venues: VenueConnection;
  widgetPageURL: Scalars['URL']['output'];
};


export type WidgetActivityGroupsActivityGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  endsInFuture?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isBookableUnit?: InputMaybe<Scalars['Boolean']['input']>;
  publicationStates?: InputMaybe<Array<PublicationState>>;
  sportIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  teacherIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  timeRange?: InputMaybe<TimeRangeInput>;
  types?: InputMaybe<Array<ActivityGroupType>>;
  venueIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type WidgetActivityGroupsVenuesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type WidgetActivityGroupsWidgetPageUrlArgs = {
  venueId: Scalars['String']['input'];
};

export type WidgetActivityGroupsSettings = {
  __typename: 'WidgetActivityGroupsSettings';
  activityTypes: Array<ActivityGroupType>;
  colorBackground: Maybe<Scalars['String']['output']>;
  colorBackgroundCard: Maybe<Scalars['String']['output']>;
  colorButton: Maybe<Scalars['String']['output']>;
  colorFont: Maybe<Scalars['String']['output']>;
  colorFontCard: Maybe<Scalars['String']['output']>;
  colorHeading: Maybe<Scalars['String']['output']>;
  fontFamily: Maybe<Scalars['String']['output']>;
};

export type WidgetActivitySchedule = WidgetInterface & {
  __typename: 'WidgetActivitySchedule';
  /** Retrieve a _paginated_ list of all `Activities` within your integrated `Venues` */
  activities: ActivityConnection;
  /** Retrieve a _paginated_ list of all `ActivityCategory`s within your integrated `Venues` */
  activityCategories: ActivityCategoryConnection;
  /** Retrieve a _paginated_ list of default and all `ActivityCategory` of `Venues` that are activated for your integration */
  activityCategoryFilterOptions: ActivityCategoryFilterOptionConnection;
  company: Company;
  /** Retrieve a _paginated_ list of all `Default ActivityCategory`s within your integrated `Venues` */
  defaultActivityCategories: ActivityCategoryConnection;
  /** Retrieve a _paginated_ list of all `Default Sports` that should be pre-selected */
  defaultSports: SportConnection;
  /** Retrieve a _paginated_ list of all `Default Teachers` of  `Venues` that are activated for your integration */
  defaultTeachers: TeacherConnection;
  id: Scalars['ID']['output'];
  /** @deprecated Moved to `WidgetInterface` */
  marketplaceURL: Scalars['URL']['output'];
  settings: WidgetActivityScheduleSettings;
  /** Retrieve a _paginated_ list of default and all `Sports` of `Venues` that are activated for your integration */
  sportFilterOptions: SportFilterOptionConnection;
  /** Retrieve a _paginated_ list of all `Venues` that are activated for your integration */
  sports: SportConnection;
  /** Retrieve a _paginated_ list of default and all `Teachers` of `Venues` that are activated for your integration */
  teacherFilterOptions: TeacherFilterOptionConnection;
  /** Retrieve a _paginated_ list of all `Teachers` of  `Venues` that are activated for your integration */
  teachers: TeacherConnection;
  /** Retrieve a _paginated_ list of all `Venues` that are activated for your integration */
  venues: VenueConnection;
  widgetPageURL: Scalars['URL']['output'];
};


export type WidgetActivityScheduleActivitiesArgs = {
  activityCategoryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  activityGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  activityGroupPublicationStates?: InputMaybe<Array<PublicationState>>;
  activityGroupTypes?: InputMaybe<Array<ActivityGroupType>>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasOnlineStream?: InputMaybe<Scalars['Boolean']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isBookableUnit?: InputMaybe<Scalars['Boolean']['input']>;
  isCancelled?: InputMaybe<Scalars['Boolean']['input']>;
  roomIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  sportIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  teacherIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  timeRange?: InputMaybe<TimeRangeInput>;
  venueIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type WidgetActivityScheduleActivityCategoriesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  venueIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type WidgetActivityScheduleActivityCategoryFilterOptionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  venueIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type WidgetActivityScheduleDefaultActivityCategoriesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  venueIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type WidgetActivityScheduleDefaultSportsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  venueIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type WidgetActivityScheduleDefaultTeachersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  venueIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type WidgetActivityScheduleSportFilterOptionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  venueIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type WidgetActivityScheduleSportsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  venueIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type WidgetActivityScheduleTeacherFilterOptionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  venueIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type WidgetActivityScheduleTeachersArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  venueIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type WidgetActivityScheduleVenuesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type WidgetActivityScheduleWidgetPageUrlArgs = {
  venueId: Scalars['String']['input'];
};

export type WidgetActivityScheduleSettings = {
  __typename: 'WidgetActivityScheduleSettings';
  colorBackground: Maybe<Scalars['String']['output']>;
  colorButton: Maybe<Scalars['String']['output']>;
  colorFont: Maybe<Scalars['String']['output']>;
  colorFontCard: Maybe<Scalars['String']['output']>;
  fontFamily: Maybe<Scalars['String']['output']>;
  groupSchedule: Scalars['Boolean']['output'];
  showCompactViewMobile: Scalars['Boolean']['output'];
  showLevel: Scalars['Boolean']['output'];
  showResource: Scalars['Boolean']['output'];
  showTrainer: Scalars['Boolean']['output'];
  spotLimitDisplayType: Maybe<ActivitySpotLimitDisplayType>;
};

export type WidgetInterface = {
  company: Company;
  id: Scalars['ID']['output'];
  marketplaceURL: Scalars['URL']['output'];
  widgetPageURL: Scalars['URL']['output'];
};


export type WidgetInterfaceWidgetPageUrlArgs = {
  venueId: Scalars['String']['input'];
};

export type WidgetPriceSettings = {
  __typename: 'WidgetPriceSettings';
  colorBackground: Maybe<Scalars['String']['output']>;
  colorBackgroundCard: Maybe<Scalars['String']['output']>;
  colorButton: Maybe<Scalars['String']['output']>;
  colorFont: Maybe<Scalars['String']['output']>;
  colorFontCard: Maybe<Scalars['String']['output']>;
  colorHeading: Maybe<Scalars['String']['output']>;
  fontFamily: Maybe<Scalars['String']['output']>;
};

export type WidgetPrices = WidgetInterface & {
  __typename: 'WidgetPrices';
  company: Company;
  id: Scalars['ID']['output'];
  invoicingVenue: Venue;
  marketplaceURL: Scalars['URL']['output'];
  /** Retrieve a _paginated_ list of all `Default Product Groups` that are activated for your integration */
  productGroups: ProductGroupConnection;
  settings: WidgetPriceSettings;
  widgetPageURL: Scalars['URL']['output'];
};


export type WidgetPricesProductGroupsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type WidgetPricesWidgetPageUrlArgs = {
  venueId: Scalars['String']['input'];
};

export type WidgetVideos = WidgetInterface & {
  __typename: 'WidgetVideos';
  company: Company;
  difficultyLevelFilterOptions: Array<RecordingDifficultyLevelFilterOption>;
  id: Scalars['ID']['output'];
  languageFilterOptions: Array<RecordingSupportedLanguageFilterOption>;
  marketplaceURL: Scalars['URL']['output'];
  /** Retrieve a _paginated_ list of all `Default Recording Categories` that are activated for your integration */
  recordingCategories: RecordingCategoryConnection;
  settings: WidgetVideosSettings;
  /** Retrieve a _paginated_ list of `SportFilterOption` */
  sportFilterOptions: SportFilterOptionConnection;
  /** Retrieve a _paginated_ list of `TeacherFilterOption` */
  teacherFilterOptions: TeacherFilterOptionConnection;
  /** Retrieve a _paginated_ list of all `Venues` that are activated for your integration */
  venues: VenueConnection;
  widgetPageURL: Scalars['URL']['output'];
};


export type WidgetVideosRecordingCategoriesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  recordingCategoryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  venueIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type WidgetVideosSportFilterOptionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type WidgetVideosTeacherFilterOptionsArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


export type WidgetVideosVenuesArgs = {
  after?: InputMaybe<Scalars['Cursor']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  recordingCategoryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  venueIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type WidgetVideosWidgetPageUrlArgs = {
  venueId: Scalars['String']['input'];
};

export type WidgetVideosSettings = {
  __typename: 'WidgetVideosSettings';
  colorBackground: Maybe<Scalars['String']['output']>;
  colorBackgroundCard: Maybe<Scalars['String']['output']>;
  colorButton: Maybe<Scalars['String']['output']>;
  colorFont: Maybe<Scalars['String']['output']>;
  colorFontCard: Maybe<Scalars['String']['output']>;
  colorHeading: Maybe<Scalars['String']['output']>;
  fontFamily: Maybe<Scalars['String']['output']>;
};

export type LoaderWidgetQueryVariables = Exact<{
  widgetId: Scalars['ID']['input'];
}>;


export type LoaderWidgetQuery = { widget: { __typename: 'WidgetActivityGroups', id: string, marketplaceURL: string, settings: { __typename: 'WidgetActivityGroupsSettings', activityTypes: Array<ActivityGroupType>, colorBackground: string | undefined, colorBackgroundCard: string | undefined, colorButton: string | undefined, colorFont: string | undefined, colorFontCard: string | undefined, colorHeading: string | undefined, fontFamily: string | undefined }, defaultTimeRange: { __typename: 'TimeRange', start: string | undefined, end: string | undefined }, venues: { __typename: 'VenueConnection', nodes: Array<{ __typename: 'Venue', id: string, name: string }> } } | { __typename: 'WidgetActivitySchedule', id: string, marketplaceURL: string, settings: { __typename: 'WidgetActivityScheduleSettings', colorFontCard: string | undefined, colorBackground: string | undefined, colorButton: string | undefined, colorFont: string | undefined, fontFamily: string | undefined, groupSchedule: boolean, showLevel: boolean, showResource: boolean, showTrainer: boolean, spotLimitDisplayType: ActivitySpotLimitDisplayType | undefined, showCompactViewMobile: boolean }, venues: { __typename: 'VenueConnection', nodes: Array<{ __typename: 'Venue', id: string, name: string }> } } | { __typename: 'WidgetPrices', id: string, marketplaceURL: string, invoicingVenue: { __typename: 'Venue', id: string }, settings: { __typename: 'WidgetPriceSettings', colorBackground: string | undefined, colorBackgroundCard: string | undefined, colorButton: string | undefined, colorFont: string | undefined, colorFontCard: string | undefined, colorHeading: string | undefined, fontFamily: string | undefined } } | { __typename: 'WidgetVideos', id: string, marketplaceURL: string, settings: { __typename: 'WidgetVideosSettings', colorBackground: string | undefined, colorBackgroundCard: string | undefined, colorButton: string | undefined, colorFont: string | undefined, colorFontCard: string | undefined, colorHeading: string | undefined, fontFamily: string | undefined }, company: { __typename: 'Company', id: string }, venues: { __typename: 'VenueConnection', nodes: Array<{ __typename: 'Venue', id: string, name: string }> } } };

export type ActivitiesWidgetQueryVariables = Exact<{
  widgetId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  publicationStates?: InputMaybe<Array<PublicationState> | PublicationState>;
  timeRange?: InputMaybe<TimeRangeInput>;
  venueIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type ActivitiesWidgetQuery = { widget: { __typename: 'WidgetActivityGroups', id: string, CAMP: { __typename: 'ActivityGroupConnection', nodes: Array<{ __typename: 'ActivityGroup', id: string, name: string, detailsPageURL: string | undefined, start: any | undefined, end: any | undefined, sessionCount: number, hasOnlineStream: boolean | undefined, imagesV2: { __typename: 'ImageV2Connection', nodes: Array<{ __typename: 'ImageV2', url: string | undefined }> } | undefined, venue: { __typename: 'Venue', id: string, name: string } }>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor: any | undefined } }, COURSE: { __typename: 'ActivityGroupConnection', nodes: Array<{ __typename: 'ActivityGroup', id: string, name: string, detailsPageURL: string | undefined, start: any | undefined, end: any | undefined, sessionCount: number, hasOnlineStream: boolean | undefined, imagesV2: { __typename: 'ImageV2Connection', nodes: Array<{ __typename: 'ImageV2', url: string | undefined }> } | undefined, venue: { __typename: 'Venue', id: string, name: string } }>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor: any | undefined } }, EDUCATION: { __typename: 'ActivityGroupConnection', nodes: Array<{ __typename: 'ActivityGroup', id: string, name: string, detailsPageURL: string | undefined, start: any | undefined, end: any | undefined, sessionCount: number, hasOnlineStream: boolean | undefined, imagesV2: { __typename: 'ImageV2Connection', nodes: Array<{ __typename: 'ImageV2', url: string | undefined }> } | undefined, venue: { __typename: 'Venue', id: string, name: string } }>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor: any | undefined } }, EVENT: { __typename: 'ActivityGroupConnection', nodes: Array<{ __typename: 'ActivityGroup', id: string, name: string, detailsPageURL: string | undefined, start: any | undefined, end: any | undefined, sessionCount: number, hasOnlineStream: boolean | undefined, imagesV2: { __typename: 'ImageV2Connection', nodes: Array<{ __typename: 'ImageV2', url: string | undefined }> } | undefined, venue: { __typename: 'Venue', id: string, name: string } }>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor: any | undefined } }, RETREAT: { __typename: 'ActivityGroupConnection', nodes: Array<{ __typename: 'ActivityGroup', id: string, name: string, detailsPageURL: string | undefined, start: any | undefined, end: any | undefined, sessionCount: number, hasOnlineStream: boolean | undefined, imagesV2: { __typename: 'ImageV2Connection', nodes: Array<{ __typename: 'ImageV2', url: string | undefined }> } | undefined, venue: { __typename: 'Venue', id: string, name: string } }>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor: any | undefined } }, WORKSHOP: { __typename: 'ActivityGroupConnection', nodes: Array<{ __typename: 'ActivityGroup', id: string, name: string, detailsPageURL: string | undefined, start: any | undefined, end: any | undefined, sessionCount: number, hasOnlineStream: boolean | undefined, imagesV2: { __typename: 'ImageV2Connection', nodes: Array<{ __typename: 'ImageV2', url: string | undefined }> } | undefined, venue: { __typename: 'Venue', id: string, name: string } }>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor: any | undefined } } } | { __typename: 'WidgetActivitySchedule' } | { __typename: 'WidgetPrices' } | { __typename: 'WidgetVideos' } };

export type PaginatedActivityGroupFragment = { __typename: 'ActivityGroupConnection', nodes: Array<{ __typename: 'ActivityGroup', id: string, name: string, detailsPageURL: string | undefined, start: any | undefined, end: any | undefined, sessionCount: number, hasOnlineStream: boolean | undefined, imagesV2: { __typename: 'ImageV2Connection', nodes: Array<{ __typename: 'ImageV2', url: string | undefined }> } | undefined, venue: { __typename: 'Venue', id: string, name: string } }>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor: any | undefined } };

export type LoadMoreWidgetQueryVariables = Exact<{
  widgetId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  publicationStates?: InputMaybe<Array<PublicationState> | PublicationState>;
  timeRange?: InputMaybe<TimeRangeInput>;
  type: ActivityGroupType;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  venueIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type LoadMoreWidgetQuery = { widget: { __typename: 'WidgetActivityGroups', id: string, activityGroups: { __typename: 'ActivityGroupConnection', nodes: Array<{ __typename: 'ActivityGroup', id: string, name: string, detailsPageURL: string | undefined, start: any | undefined, end: any | undefined, sessionCount: number, hasOnlineStream: boolean | undefined, imagesV2: { __typename: 'ImageV2Connection', nodes: Array<{ __typename: 'ImageV2', url: string | undefined }> } | undefined, venue: { __typename: 'Venue', id: string, name: string } }>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor: any | undefined } } } | { __typename: 'WidgetActivitySchedule' } | { __typename: 'WidgetPrices' } | { __typename: 'WidgetVideos' } };

export type ActivityScheduleWidgetQueryVariables = Exact<{
  widgetId: Scalars['ID']['input'];
  timeRange?: InputMaybe<TimeRangeInput>;
  types?: InputMaybe<Array<ActivityGroupType> | ActivityGroupType>;
  activityGroupIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  sportIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  teacherIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type ActivityScheduleWidgetQuery = { widget: { __typename: 'WidgetActivityGroups' } | { __typename: 'WidgetActivitySchedule', id: string, activities: { __typename: 'ActivityConnection', nodes: Array<{ __typename: 'Activity', id: string, name: string | undefined, start: any, end: any, detailsPageURL: string | undefined, hasOnlineStream: boolean, isCancelled: boolean, activityGroup: { __typename: 'ActivityGroup', id: string, color: any | undefined, detailsPageURL: string | undefined, name: string, level: ActivityDifficultyLevel | undefined, category: { __typename: 'ActivityCategory', id: string, name: string }, limited: { __typename: 'Limited', freeSpots: number, totalSpots: number } | undefined, sport: { __typename: 'Sport', id: string, name: string } | undefined, venue: { __typename: 'Venue', id: string, name: string } }, limited: { __typename: 'Limited', freeSpots: number, totalSpots: number } | undefined, room: { __typename: 'Room', id: string, name: string } | undefined, teacher: { __typename: 'Teacher', id: string, name: string, imageV2: { __typename: 'ImageV2', url: string | undefined } | undefined } | undefined }>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor: any | undefined } } } | { __typename: 'WidgetPrices' } | { __typename: 'WidgetVideos' } };

export type FiltersWidgetQueryVariables = Exact<{
  widgetId: Scalars['ID']['input'];
}>;


export type FiltersWidgetQuery = { widget: { __typename: 'WidgetActivityGroups' } | { __typename: 'WidgetActivitySchedule', id: string, activityCategories: { __typename: 'ActivityCategoryConnection', nodes: Array<{ __typename: 'ActivityCategory', id: string, name: string, color: any | undefined, venue: { __typename: 'Venue', id: string, name: string } }> }, sports: { __typename: 'SportConnection', nodes: Array<{ __typename: 'Sport', id: string, name: string }> }, teachers: { __typename: 'TeacherConnection', nodes: Array<{ __typename: 'Teacher', id: string, name: string, imageV2: { __typename: 'ImageV2', url: string | undefined } | undefined }> } } | { __typename: 'WidgetPrices' } | { __typename: 'WidgetVideos' } };

export type FiltersActivityCategoriesWidgetQueryVariables = Exact<{
  widgetId: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type FiltersActivityCategoriesWidgetQuery = { widget: { __typename: 'WidgetActivityGroups' } | { __typename: 'WidgetActivitySchedule', id: string, activityCategories: { __typename: 'ActivityCategoryConnection', nodes: Array<{ __typename: 'ActivityCategory', id: string, name: string, color: any | undefined, venue: { __typename: 'Venue', id: string, name: string } }>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor: any | undefined } } } | { __typename: 'WidgetPrices' } | { __typename: 'WidgetVideos' } };

export type FiltersSportsWidgetQueryVariables = Exact<{
  widgetId: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type FiltersSportsWidgetQuery = { widget: { __typename: 'WidgetActivityGroups' } | { __typename: 'WidgetActivitySchedule', id: string, sports: { __typename: 'SportConnection', nodes: Array<{ __typename: 'Sport', id: string, name: string }>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor: any | undefined } } } | { __typename: 'WidgetPrices' } | { __typename: 'WidgetVideos' } };

export type FiltersTeachersWidgetQueryVariables = Exact<{
  widgetId: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type FiltersTeachersWidgetQuery = { widget: { __typename: 'WidgetActivityGroups' } | { __typename: 'WidgetActivitySchedule', id: string, teachers: { __typename: 'TeacherConnection', nodes: Array<{ __typename: 'Teacher', id: string, name: string, imageV2: { __typename: 'ImageV2', url: string | undefined } | undefined }>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor: any | undefined } } } | { __typename: 'WidgetPrices' } | { __typename: 'WidgetVideos' } };

export type DefaultTeachersWidgetQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type DefaultTeachersWidgetQuery = { widget: { __typename: 'WidgetActivityGroups' } | { __typename: 'WidgetActivitySchedule', id: string, defaultTeachers: { __typename: 'TeacherConnection', nodes: Array<{ __typename: 'Teacher', id: string, name: string, imageV2: { __typename: 'ImageV2', url: string | undefined } | undefined }>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor: any | undefined } } } | { __typename: 'WidgetPrices' } | { __typename: 'WidgetVideos' } };

export type DefaultSportsWidgetQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type DefaultSportsWidgetQuery = { widget: { __typename: 'WidgetActivityGroups' } | { __typename: 'WidgetActivitySchedule', id: string, defaultSports: { __typename: 'SportConnection', nodes: Array<{ __typename: 'Sport', id: string, name: string }>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor: any | undefined } } } | { __typename: 'WidgetPrices' } | { __typename: 'WidgetVideos' } };

export type DefaultActivityGroupsWidgetQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['Cursor']['input']>;
}>;


export type DefaultActivityGroupsWidgetQuery = { widget: { __typename: 'WidgetActivityGroups' } | { __typename: 'WidgetActivitySchedule', id: string, defaultActivityCategories: { __typename: 'ActivityCategoryConnection', nodes: Array<{ __typename: 'ActivityCategory', id: string, name: string, color: any | undefined, venue: { __typename: 'Venue', id: string, name: string } }>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor: any | undefined } } } | { __typename: 'WidgetPrices' } | { __typename: 'WidgetVideos' } };

export type PricesWidgetQueryVariables = Exact<{
  widgetId: Scalars['ID']['input'];
  purchasedAtVenueId: Scalars['ID']['input'];
}>;


export type PricesWidgetQuery = { widget: { __typename: 'WidgetActivityGroups' } | { __typename: 'WidgetActivitySchedule' } | { __typename: 'WidgetPrices', id: string, productGroups: { __typename: 'ProductGroupConnection', nodes: Array<{ __typename: 'ProductGroup', id: string, name: string, priority: number, products: { __typename: 'ProductConnection', nodes: Array<{ __typename: 'Card', id: string, name: string, cardType: CardType, isTrialCard: boolean, detailsPageURL: string, price: { __typename: 'MonetaryValue', value: number, currency: string }, purchaseInformation: { __typename: 'PurchaseInformation', checkoutURL: string } | undefined, usages: Array<{ __typename: 'UsageLimit', usageLimit: number }>, validity: { __typename: 'TimePeriod', duration: { __typename: 'Interval', value: number, unit: IntervalUnit } } | undefined } | { __typename: 'Membership', id: string, name: string, detailsPageURL: string, paymentPlan: { __typename: 'PaymentPlan', offset: number | undefined, initial: { __typename: 'MonetaryValue', value: number, currency: string } | undefined, interval: { __typename: 'Interval', value: number, unit: IntervalUnit }, promotion: { __typename: 'Promotion', period: { __typename: 'Interval', value: number, unit: IntervalUnit }, price: { __typename: 'MonetaryValue', value: number, currency: string } } | undefined, recurring: { __typename: 'MonetaryValue', value: number, currency: string } }, purchaseInformation: { __typename: 'PurchaseInformation', checkoutURL: string, description: string | undefined } | undefined, runtime: { __typename: 'Runtime', initial: { __typename: 'Interval', value: number, unit: IntervalUnit }, renewal: { __typename: 'Renewal', interval: { __typename: 'Interval', value: number, unit: IntervalUnit } } | undefined }, usages: Array<{ __typename: 'UsageLimit', unit: UsageLimitUnit, usageLimit: number, repeating: { __typename: 'Repeating', interval: { __typename: 'Interval', value: number, unit: IntervalUnit } } | undefined }> }>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor: any | undefined } } }>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor: any | undefined } } } | { __typename: 'WidgetVideos' } };

export type VideosWidgetQueryVariables = Exact<{
  widgetId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  venueIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type VideosWidgetQuery = { widget: { __typename: 'WidgetActivityGroups' } | { __typename: 'WidgetActivitySchedule' } | { __typename: 'WidgetPrices' } | { __typename: 'WidgetVideos', id: string, recordingCategories: { __typename: 'RecordingCategoryConnection', nodes: Array<{ __typename: 'RecordingCategory', id: string, name: string, recordings: { __typename: 'RecordingConnection', nodes: Array<{ __typename: 'Recording', id: string, detailsPageURL: string, name: string, duration: number | undefined, level: RecordingDifficultyLevel | undefined, language: RecordingSupportedLanguage | undefined, image: { __typename: 'ImageV2', id: string, url: string | undefined } | undefined, venue: { __typename: 'Venue', id: string, name: string }, teacher: { __typename: 'Teacher', id: string, name: string, imageV2: { __typename: 'ImageV2', id: string, url: string | undefined } | undefined } | undefined }>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor: any | undefined } } }>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor: any | undefined } } } };

export type PaginatedRecordingFragment = { __typename: 'RecordingConnection', nodes: Array<{ __typename: 'Recording', id: string, detailsPageURL: string, name: string, duration: number | undefined, level: RecordingDifficultyLevel | undefined, language: RecordingSupportedLanguage | undefined, image: { __typename: 'ImageV2', id: string, url: string | undefined } | undefined, venue: { __typename: 'Venue', id: string, name: string }, teacher: { __typename: 'Teacher', id: string, name: string, imageV2: { __typename: 'ImageV2', id: string, url: string | undefined } | undefined } | undefined }>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor: any | undefined } };

export type RecordingCategoryWidgetQueryVariables = Exact<{
  widgetId: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['Cursor']['input']>;
  recordingCategoryId: Scalars['ID']['input'];
  venueIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type RecordingCategoryWidgetQuery = { widget: { __typename: 'WidgetActivityGroups' } | { __typename: 'WidgetActivitySchedule' } | { __typename: 'WidgetPrices' } | { __typename: 'WidgetVideos', id: string, recordingCategories: { __typename: 'RecordingCategoryConnection', nodes: Array<{ __typename: 'RecordingCategory', id: string, recordings: { __typename: 'RecordingConnection', nodes: Array<{ __typename: 'Recording', id: string, detailsPageURL: string, name: string, duration: number | undefined, level: RecordingDifficultyLevel | undefined, language: RecordingSupportedLanguage | undefined, image: { __typename: 'ImageV2', id: string, url: string | undefined } | undefined, venue: { __typename: 'Venue', id: string, name: string }, teacher: { __typename: 'Teacher', id: string, name: string, imageV2: { __typename: 'ImageV2', id: string, url: string | undefined } | undefined } | undefined }>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, endCursor: any | undefined } } }> } } };

export const PaginatedActivityGroupFragmentDoc = gql`
    fragment PaginatedActivityGroup on ActivityGroupConnection {
  nodes {
    id
    imagesV2(first: 1) {
      nodes {
        url(size: SMALL)
      }
    }
    name
    detailsPageURL
    venue {
      id
      name
    }
    start
    end
    sessionCount
    hasOnlineStream
  }
  pageInfo {
    hasNextPage
    endCursor
  }
}
    `;
export const PaginatedRecordingFragmentDoc = gql`
    fragment PaginatedRecording on RecordingConnection {
  nodes {
    id
    detailsPageURL
    image {
      id
      url(size: SMALL)
    }
    name
    venue {
      id
      name
    }
    duration
    level
    language
    teacher {
      id
      name
      imageV2 {
        id
        url(size: SMALL)
      }
    }
  }
  pageInfo {
    hasNextPage
    endCursor
  }
}
    `;
export const LoaderWidgetDocument = gql`
    query LoaderWidget($widgetId: ID!) {
  widget(id: $widgetId) {
    __typename
    ... on WidgetActivitySchedule {
      id
      marketplaceURL
      settings {
        colorFontCard
        colorBackground
        colorButton
        colorFont
        fontFamily
        groupSchedule
        showLevel
        showResource
        showTrainer
        spotLimitDisplayType
        showCompactViewMobile
      }
      venues {
        nodes {
          id
          name
        }
      }
    }
    ... on WidgetPrices {
      id
      marketplaceURL
      invoicingVenue {
        id
      }
      settings {
        colorBackground
        colorBackgroundCard
        colorButton
        colorFont
        colorFontCard
        colorHeading
        fontFamily
      }
    }
    ... on WidgetActivityGroups {
      id
      marketplaceURL
      settings {
        activityTypes
        colorBackground
        colorBackgroundCard
        colorButton
        colorFont
        colorFontCard
        colorHeading
        fontFamily
      }
      defaultTimeRange {
        start
        end
      }
      venues {
        nodes {
          id
          name
        }
      }
    }
    ... on WidgetVideos {
      id
      marketplaceURL
      settings {
        colorBackground
        colorBackgroundCard
        colorButton
        colorFont
        colorFontCard
        colorHeading
        fontFamily
      }
      company {
        id
      }
      venues {
        nodes {
          id
          name
        }
      }
    }
  }
}
    `;
export const ActivitiesWidgetDocument = gql`
    query ActivitiesWidget($widgetId: ID!, $first: Int, $publicationStates: [PublicationState!], $timeRange: TimeRangeInput, $venueIds: [ID!]) {
  widget(id: $widgetId) {
    __typename
    ... on WidgetActivityGroups {
      id
      CAMP: activityGroups(
        types: [CAMP]
        endsInFuture: true
        first: $first
        timeRange: $timeRange
        publicationStates: $publicationStates
        venueIds: $venueIds
      ) {
        ...PaginatedActivityGroup
      }
      COURSE: activityGroups(
        types: [COURSE]
        endsInFuture: true
        first: $first
        timeRange: $timeRange
        publicationStates: $publicationStates
        venueIds: $venueIds
      ) {
        ...PaginatedActivityGroup
      }
      EDUCATION: activityGroups(
        types: [EDUCATION]
        endsInFuture: true
        first: $first
        timeRange: $timeRange
        publicationStates: $publicationStates
        venueIds: $venueIds
      ) {
        ...PaginatedActivityGroup
      }
      EVENT: activityGroups(
        types: [EVENT]
        endsInFuture: true
        first: $first
        timeRange: $timeRange
        publicationStates: $publicationStates
        venueIds: $venueIds
      ) {
        ...PaginatedActivityGroup
      }
      RETREAT: activityGroups(
        types: [RETREAT]
        endsInFuture: true
        first: $first
        timeRange: $timeRange
        publicationStates: $publicationStates
        venueIds: $venueIds
      ) {
        ...PaginatedActivityGroup
      }
      WORKSHOP: activityGroups(
        types: [WORKSHOP]
        endsInFuture: true
        first: $first
        timeRange: $timeRange
        publicationStates: $publicationStates
        venueIds: $venueIds
      ) {
        ...PaginatedActivityGroup
      }
    }
  }
}
    ${PaginatedActivityGroupFragmentDoc}`;
export const LoadMoreWidgetDocument = gql`
    query LoadMoreWidget($widgetId: ID!, $first: Int, $publicationStates: [PublicationState!], $timeRange: TimeRangeInput, $type: ActivityGroupType!, $after: Cursor, $venueIds: [ID!]) {
  widget(id: $widgetId) {
    __typename
    ... on WidgetActivityGroups {
      id
      activityGroups(
        endsInFuture: true
        first: $first
        timeRange: $timeRange
        types: [$type]
        after: $after
        publicationStates: $publicationStates
        venueIds: $venueIds
      ) {
        ...PaginatedActivityGroup
      }
    }
  }
}
    ${PaginatedActivityGroupFragmentDoc}`;
export const ActivityScheduleWidgetDocument = gql`
    query ActivityScheduleWidget($widgetId: ID!, $timeRange: TimeRangeInput, $types: [ActivityGroupType!], $activityGroupIds: [ID!], $sportIds: [ID!], $teacherIds: [ID!], $first: Int, $after: Cursor) {
  widget(id: $widgetId) {
    __typename
    ... on WidgetActivitySchedule {
      id
      activities(
        activityGroupTypes: $types
        activityGroupPublicationStates: [ACTIVE, VIEW_ONLY]
        timeRange: $timeRange
        first: $first
        after: $after
        activityGroupIds: $activityGroupIds
        sportIds: $sportIds
        teacherIds: $teacherIds
        isArchived: false
      ) {
        nodes {
          id
          name
          start
          end
          activityGroup {
            id
            category {
              id
              name
            }
            color
            detailsPageURL
            name
            level
            limited {
              freeSpots
              totalSpots
            }
            sport {
              id
              name
            }
            venue {
              id
              name
            }
          }
          detailsPageURL
          hasOnlineStream
          isCancelled
          limited {
            freeSpots
            totalSpots
          }
          room {
            id
            name
          }
          teacher {
            id
            name
            imageV2 {
              url(size: X_SMALL)
            }
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
}
    `;
export const FiltersWidgetDocument = gql`
    query FiltersWidget($widgetId: ID!) {
  widget(id: $widgetId) {
    __typename
    ... on WidgetActivitySchedule {
      id
      activityCategories {
        nodes {
          id
          name
          color
          venue {
            id
            name
          }
        }
      }
      sports {
        nodes {
          id
          name
        }
      }
      teachers {
        nodes {
          id
          name
          imageV2 {
            url(size: X_SMALL)
          }
        }
      }
    }
  }
}
    `;
export const FiltersActivityCategoriesWidgetDocument = gql`
    query FiltersActivityCategoriesWidget($widgetId: ID!, $after: Cursor) {
  widget(id: $widgetId) {
    __typename
    ... on WidgetActivitySchedule {
      id
      activityCategories(after: $after) {
        nodes {
          id
          name
          color
          venue {
            id
            name
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
}
    `;
export const FiltersSportsWidgetDocument = gql`
    query FiltersSportsWidget($widgetId: ID!, $after: Cursor) {
  widget(id: $widgetId) {
    __typename
    ... on WidgetActivitySchedule {
      id
      sports(after: $after) {
        nodes {
          id
          name
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
}
    `;
export const FiltersTeachersWidgetDocument = gql`
    query FiltersTeachersWidget($widgetId: ID!, $after: Cursor) {
  widget(id: $widgetId) {
    __typename
    ... on WidgetActivitySchedule {
      id
      teachers(after: $after) {
        nodes {
          id
          name
          imageV2 {
            url(size: X_SMALL)
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
}
    `;
export const DefaultTeachersWidgetDocument = gql`
    query DefaultTeachersWidget($id: ID!, $after: Cursor) {
  widget(id: $id) {
    __typename
    ... on WidgetActivitySchedule {
      id
      defaultTeachers(after: $after) {
        nodes {
          id
          name
          imageV2 {
            url(size: X_SMALL)
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
}
    `;
export const DefaultSportsWidgetDocument = gql`
    query DefaultSportsWidget($id: ID!, $after: Cursor) {
  widget(id: $id) {
    __typename
    ... on WidgetActivitySchedule {
      id
      defaultSports(after: $after) {
        nodes {
          id
          name
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
}
    `;
export const DefaultActivityGroupsWidgetDocument = gql`
    query DefaultActivityGroupsWidget($id: ID!, $after: Cursor) {
  widget(id: $id) {
    __typename
    ... on WidgetActivitySchedule {
      id
      defaultActivityCategories(after: $after) {
        nodes {
          id
          name
          color
          venue {
            id
            name
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
}
    `;
export const PricesWidgetDocument = gql`
    query PricesWidget($widgetId: ID!, $purchasedAtVenueId: ID!) {
  widget(id: $widgetId) {
    __typename
    ... on WidgetPrices {
      id
      productGroups {
        nodes {
          id
          name
          priority
          products(purchasableAtVenueId: $purchasedAtVenueId) {
            nodes {
              ... on Card {
                __typename
                id
                name
                cardType
                isTrialCard
                detailsPageURL(purchaseAtVenueId: $purchasedAtVenueId)
                price {
                  value
                  currency
                }
                purchaseInformation {
                  checkoutURL(purchaseAtVenueId: $purchasedAtVenueId)
                }
                usages {
                  usageLimit
                }
                validity {
                  duration {
                    value
                    unit
                  }
                }
              }
              ... on Membership {
                __typename
                id
                name
                detailsPageURL(purchaseAtVenueId: $purchasedAtVenueId)
                paymentPlan {
                  initial {
                    value
                    currency
                  }
                  interval {
                    value
                    unit
                  }
                  offset
                  promotion {
                    period {
                      value
                      unit
                    }
                    price {
                      value
                      currency
                    }
                  }
                  recurring {
                    value
                    currency
                  }
                }
                purchaseInformation {
                  checkoutURL(purchaseAtVenueId: $purchasedAtVenueId)
                  description
                }
                runtime {
                  initial {
                    value
                    unit
                  }
                  renewal {
                    interval {
                      value
                      unit
                    }
                  }
                }
                usages {
                  repeating {
                    interval {
                      value
                      unit
                    }
                  }
                  unit
                  usageLimit
                }
              }
            }
            pageInfo {
              hasNextPage
              endCursor
            }
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
}
    `;
export const VideosWidgetDocument = gql`
    query VideosWidget($widgetId: ID!, $first: Int, $after: Cursor, $venueIds: [ID!]) {
  widget(id: $widgetId) {
    __typename
    ... on WidgetVideos {
      id
      recordingCategories(first: $first, after: $after, venueIds: $venueIds) {
        nodes {
          id
          name
          recordings(first: 6, currentlyAvailable: true) {
            ...PaginatedRecording
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
}
    ${PaginatedRecordingFragmentDoc}`;
export const RecordingCategoryWidgetDocument = gql`
    query RecordingCategoryWidget($widgetId: ID!, $first: Int, $after: Cursor, $recordingCategoryId: ID!, $venueIds: [ID!]) {
  widget(id: $widgetId) {
    __typename
    ... on WidgetVideos {
      id
      recordingCategories(
        recordingCategoryIds: [$recordingCategoryId]
        venueIds: $venueIds
      ) {
        nodes {
          id
          recordings(first: $first, after: $after, currentlyAvailable: true) {
            ...PaginatedRecording
          }
        }
      }
    }
  }
}
    ${PaginatedRecordingFragmentDoc}`;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string, variables?: any) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, _variables) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    LoaderWidget(variables: LoaderWidgetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<LoaderWidgetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<LoaderWidgetQuery>(LoaderWidgetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'LoaderWidget', 'query', variables);
    },
    ActivitiesWidget(variables: ActivitiesWidgetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ActivitiesWidgetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ActivitiesWidgetQuery>(ActivitiesWidgetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ActivitiesWidget', 'query', variables);
    },
    LoadMoreWidget(variables: LoadMoreWidgetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<LoadMoreWidgetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<LoadMoreWidgetQuery>(LoadMoreWidgetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'LoadMoreWidget', 'query', variables);
    },
    ActivityScheduleWidget(variables: ActivityScheduleWidgetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ActivityScheduleWidgetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ActivityScheduleWidgetQuery>(ActivityScheduleWidgetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'ActivityScheduleWidget', 'query', variables);
    },
    FiltersWidget(variables: FiltersWidgetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FiltersWidgetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FiltersWidgetQuery>(FiltersWidgetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'FiltersWidget', 'query', variables);
    },
    FiltersActivityCategoriesWidget(variables: FiltersActivityCategoriesWidgetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FiltersActivityCategoriesWidgetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FiltersActivityCategoriesWidgetQuery>(FiltersActivityCategoriesWidgetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'FiltersActivityCategoriesWidget', 'query', variables);
    },
    FiltersSportsWidget(variables: FiltersSportsWidgetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FiltersSportsWidgetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FiltersSportsWidgetQuery>(FiltersSportsWidgetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'FiltersSportsWidget', 'query', variables);
    },
    FiltersTeachersWidget(variables: FiltersTeachersWidgetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FiltersTeachersWidgetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FiltersTeachersWidgetQuery>(FiltersTeachersWidgetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'FiltersTeachersWidget', 'query', variables);
    },
    DefaultTeachersWidget(variables: DefaultTeachersWidgetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DefaultTeachersWidgetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DefaultTeachersWidgetQuery>(DefaultTeachersWidgetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DefaultTeachersWidget', 'query', variables);
    },
    DefaultSportsWidget(variables: DefaultSportsWidgetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DefaultSportsWidgetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DefaultSportsWidgetQuery>(DefaultSportsWidgetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DefaultSportsWidget', 'query', variables);
    },
    DefaultActivityGroupsWidget(variables: DefaultActivityGroupsWidgetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DefaultActivityGroupsWidgetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<DefaultActivityGroupsWidgetQuery>(DefaultActivityGroupsWidgetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'DefaultActivityGroupsWidget', 'query', variables);
    },
    PricesWidget(variables: PricesWidgetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PricesWidgetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<PricesWidgetQuery>(PricesWidgetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'PricesWidget', 'query', variables);
    },
    VideosWidget(variables: VideosWidgetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<VideosWidgetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<VideosWidgetQuery>(VideosWidgetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'VideosWidget', 'query', variables);
    },
    RecordingCategoryWidget(variables: RecordingCategoryWidgetQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RecordingCategoryWidgetQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RecordingCategoryWidgetQuery>(RecordingCategoryWidgetDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'RecordingCategoryWidget', 'query', variables);
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;